import appsFlyerSmartBanner from 'shared/experiments/browser/appsFlyerSmartBanner'
import ctaButtonOnAllCSW from 'shared/experiments/browser/ctaButtonOnAllCSW/eventsTracking'
import homeOneActivation from 'shared/experiments/browser/homeOne'
import oosReplacementProductOverlayTracking from 'shared/experiments/browser/oosReplacementProductOverlay/eventsTracking'
import oosReplacementProductOverlayHelper from 'shared/experiments/browser/oosReplacementProductOverlay/helper'
import pdpAddToCartAndApplyTracking from 'shared/experiments/browser/pdpAddToCartAndApplyTracking/eventsTracking'
import pdpCswTitleChange from 'shared/experiments/browser/pdpCswTitleChange'
import pdpVariantsPosition from 'shared/experiments/browser/pdpVariantsPosition'
import pdpVariantsPositionEventsTracking from 'shared/experiments/browser/pdpVariantsPosition/eventsTracking'
import rebrandingText from 'shared/experiments/browser/rebrandingText'
import pdpXsellSliderNewAlgoEventsTracking from 'shared/experiments/browser/xsellTopSlider/eventsTracking'
import { ODS_PDP_MODAL } from 'shared/experiments/consts'
import { bindExperimentActivation } from 'shared/experiments/utils/experiments'
import { initQueryIDForVariants } from 'views/assets/scripts/algoliaTracking'
import buyBoxSticky from 'views/assets/scripts/buyBoxSticky'
import chargeUrlSearchParams from 'views/assets/scripts/chargeUrlSearchParams'
import dismiss from 'views/assets/scripts/dismiss'
import emailNotification from 'views/assets/scripts/emailNotification'
import {
  createFCWidgetForLogin,
  createFCWidgetForProductConsultationCallbackForm,
  createFCWidgetForProductConsultationMessageForm,
} from 'views/assets/scripts/friendlyCaptcha'
import handleRatingsAndQnaTabsClicks from 'views/assets/scripts/handleRatingsAndQnaTabsClicks'
import loadingScript from 'views/assets/scripts/isFormSubmitting'
import loginModal from 'views/assets/scripts/loginModal'
import { initMediaGalleries } from 'views/assets/scripts/MediaGallery'
import notepad from 'views/assets/scripts/notepad'
import nowCountDown from 'views/assets/scripts/nowCountdown'
import nowModal from 'views/assets/scripts/nowModal'
import prescriptionType from 'views/assets/scripts/prescriptionType'
import productConsultation from 'views/assets/scripts/productConsultation'
import registerSliderStretcher from 'views/assets/scripts/registerSliderStretcher'
import runScripts from 'views/assets/scripts/runScripts'
import scrollableTables from 'views/assets/scripts/scrollableTables'
import { initSlider as slider } from 'views/assets/scripts/slider'
import toggleClass from 'views/assets/scripts/toggleClass'
import videoBox from 'views/assets/scripts/videoBox'
import zoomableImages from 'views/assets/scripts/zoomableImages'
import lazyYoutube from 'views/components/organisms/LazyYoutube/lazyYoutube'
import initClientScriptsXsellSellerModal from 'views/components/organisms/XsellSellerModal/initClientScripts'
import mountBuyBoxFormContainer from 'views/containers/browser/BuyBoxSendEmailFormContainer/mountBuyBoxEmailFormContainer'
import mountLastActivityContainer from 'views/containers/browser/LastActivityContainer/mountLastActivityContainer'
import mountNowCountdownContainer from 'views/containers/browser/NowCountdownContainer/mountNowCountdownContainer'
import mountNowLabelWithZipInteractionContainer from 'views/containers/browser/NowLabelWithZipInteractionContainer/mountNowLabelWithZipInteractionContainer'
import mountProductRatingsContainer from 'views/containers/browser/ProductRatingsContainer/mountProductRatingsContainer'
import mountProductVariantsAttributes from 'views/containers/browser/ProductVariantsAttributesContainer/mountProductVariantsAttributes'
import mountProductVariantsContainer from 'views/containers/browser/ProductVariantsContainer/mountProductVariantsContainer'
import mountSubscriptionClientContainer from 'views/containers/browser/SubscriptionClientContainer/mountSubscriptionClientContainer'

const animateCartButton = loadingScript({
  formSelector: '[name^=buy-]',
  buttonId: 'AddToCartButton',
  transitionDurationInSec: 1,
  preserveWidth: true,
})

const experimentActivation = () =>
  bindExperimentActivation({
    selector: '#odsModalButton',
    event: 'click',
    experimentName: ODS_PDP_MODAL,
  })

runScripts(
  ctaButtonOnAllCSW,
  initMediaGalleries,
  appsFlyerSmartBanner,
  pdpVariantsPosition,
  experimentActivation,
  zoomableImages,
  chargeUrlSearchParams,
  slider,
  videoBox,
  registerSliderStretcher,
  nowModal,
  emailNotification,
  toggleClass,
  productConsultation,
  scrollableTables,
  mountLastActivityContainer,
  mountProductRatingsContainer,
  mountProductVariantsContainer,
  mountSubscriptionClientContainer,
  prescriptionType,
  loginModal,
  buyBoxSticky,
  dismiss,
  nowCountDown,
  initQueryIDForVariants,
  handleRatingsAndQnaTabsClicks,
  notepad,
  lazyYoutube,
  pdpXsellSliderNewAlgoEventsTracking,
  animateCartButton,
  oosReplacementProductOverlayHelper,
  oosReplacementProductOverlayTracking,
  pdpVariantsPositionEventsTracking,
  mountProductVariantsAttributes,
  initClientScriptsXsellSellerModal,
  createFCWidgetForLogin,
  createFCWidgetForProductConsultationCallbackForm,
  createFCWidgetForProductConsultationMessageForm,
  pdpAddToCartAndApplyTracking,
  mountNowLabelWithZipInteractionContainer,
  mountNowCountdownContainer,
  homeOneActivation,
  rebrandingText,
  pdpCswTitleChange,
  mountBuyBoxFormContainer
)
